import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Card } from "reactstrap";
import MoreIcon from "../../../../images/moreIcon.png";
import "./CardApp.css";
import { useWindowDimensions } from "../../../../utils/useWindowDimensions";

export const CardApp = (props) => {
  const [active, setActive] = useState(false);
  const { width, height } = useWindowDimensions();

  useEffect(() => {
    // first, check if the card is active (i.e. there is a token)
    if (
      window.localStorage.getItem(props.name_token) !== undefined &&
      window.localStorage.getItem(props.name_token) !== "null" &&
      window.localStorage.getItem(props.name_token) !== null
    ) {
      setActive(true);
    }
  }, []);

  // useEffect(() => {
  //   if (active) {
  //     // next, place it and add the effect
  //     const article = document.getElementById(props.name_app);

  //     // to compute the center of the card retrieve its coordinates and dimensions
  //     const { x, y, width, height } = article.getBoundingClientRect();
  //     const cx = x + width / 2;
  //     const cy = y + height / 2;

  //     // following the mousemove event compute the distance betwen the cursor and the center of the card
  //     function handleMove(e) {
  //       const { pageX, pageY } = e;

  //       // ! consider the relative distance in the [-1, 1] range
  //       const dx = (cx - pageX) / (width / 2);
  //       const dy = (cy - pageY) / (height / 2);

  //       // rotate the card around the x axis, according to the vertical distance, and around the y acis, according to the horizontal gap
  //       this.style.transform = `rotateX(${1 * dy * -1}deg) rotateY(${
  //         1 * dx
  //       }deg)`;
  //     }

  //     // following the mouseout event reset the transform property
  //     function handleOut() {
  //       this.style.transform = "initial";
  //     }

  //     article.addEventListener("mousemove", handleMove);
  //     article.addEventListener("mouseout", handleOut);
  //   }
  // }, [active]);

  const MyButton = styled.button`
    &:hover {
      transition: ${active ? "all 0.4s ease-in-out" : null};
      background-color: ${active ? props.color : null};
      border-color: ${active ? props.color : null};
      color: ${active ? "white" : null};
    }
  `;

  return (
    <div style={{ marginTop: 100 }}>
      {width > 100 ? (
        <article
          id={props.name_app}
          className="cardApp"
          style={active ? null : { backgroundColor: "#CECECE" }}
        >
          <figure>
            <img
              alt={`${props.name_app} icon`}
              src={props.icon}
              style={
                active
                  ? null
                  : {
                      backgroundColor: "#CECECE",
                      cursor: "default",
                      boxShadow: "1px 2px 3px black, -1px 2px 3px black",
                    }
              }
            />
          </figure>
          <div>
            <p className="description">{props.text}</p>
            {props.name_app === "WAVE" || props.name_app === "OFFSHORE WIND" ? (
              <div
                style={{
                  display: "flex",
                  margin: "10px 20px",
                  padding: "5px 10px 7px 10px",
                  border: "1px solid #767676",
                  borderRadius: 10,
                }}
              >
                <div
                  style={{
                    flex: 4.5,
                    lineHeight: 1.5,
                    fontSize: 12,
                    color: "#444444",
                  }}
                >
                  In Cooperation with Marine Offshore Renewable Energy Lab
                </div>
                <div style={{ flex: 1 }}>
                  <img
                    alt="more"
                    src={MoreIcon}
                    style={{ width: "37px", height: "auto", marginLeft: 10 }}
                  ></img>
                </div>
              </div>
            ) : null}

            <div
              style={{
                position: "absolute",
                bottom: 20,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div>
                <a
                  href={
                    active
                      ? `${props.url}?auth=${localStorage.getItem(
                          props.name_token
                        )}`
                      : null
                  }
                >
                  <MyButton
                    className={
                      active ? "buttonApp" : "buttonApp buttonAppDisabled"
                    }
                    disabled={!active}
                    style={
                      props.name_app.length <= 4
                        ? {
                            padding: "0px 30px",
                          }
                        : null
                    }
                  >
                    <h1 style={{ margin: 5 }}>{props.name_app}</h1>
                  </MyButton>
                </a>
              </div>
            </div>
          </div>
        </article>
      ) : (
        <Card
          style={{
            backgroundColor: "white",
            border: "1px solid #767676",
            borderRadius: 10,
            padding: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            {props.name_app}
          </div>

          <div>
            <a
              href={
                active
                  ? `${props.url}?auth=${localStorage.getItem(
                      props.name_token
                    )}`
                  : null
              }
            >
              <MyButton
                className={active ? "buttonApp" : "buttonApp buttonAppDisabled"}
                disabled={!active}
                style={{
                  padding: "0px 40px",
                }}
              >
                <h6 style={{ margin: 5 }}>ENTER</h6>
              </MyButton>
            </a>
          </div>
        </Card>
      )}
    </div>
  );
};

export default CardApp;
